import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import CustomBreadcrumb from '../../../components/CustomBreadcrumb';
import styles from './stylesheets/MetadataInfo.module.css';
import { TabMenu } from 'primereact/tabmenu';
import CallSettings from './CallSettings';
import WhatsappProfile from './WhatsappProfile';
import CatalogueConfig from './CatalogueConfig';
import TableActionsContainer from '../../../components/CustomTable/TableActionsContainer';
import { CustomButton } from '../../../components/CustomButton';
import Insight from './Insight';
import BlockedUsersList from './BlockedUsersList';

const MetaDataInfo = () => {
  const { metadataId } = useParams();
  const navigate = useNavigate();

  const [activeTab, setActiveTab] = useState('callSettings');

  const tabItems = [
    {
      label: 'Call Settings',
      icon: 'pi pi-phone',
      command: () => setActiveTab('callSettings'),
    },
    {
      label: 'WhatsApp Profile',
      icon: 'pi pi-comments',
      command: () => setActiveTab('whatsappProfile'),
    },
    {
      label: 'Catalogue',
      icon: 'pi pi-shopping-bag',
      command: () => setActiveTab('catalogConfig'),
    },
    {
      label: 'Usage',
      icon: 'pi pi-chart-line',
      command: () => setActiveTab('usageConfig'),
    },
    {
      label: 'Blocked Users',
      icon: 'pi pi-user',
      command: () => setActiveTab('blockedUsers'),
    },
  ];
  const tabMap = ['callSettings', 'whatsappProfile', 'catalogConfig', 'usageConfig', 'blockedUsers'];

  return (
    <div>
      <CustomBreadcrumb
        home={{ label: 'Marketplace', url: '/marketplace' }}
        itemslist={[
          { label: 'Metadata', url: '/marketplace/metadata' },
          { label: `${metadataId}`, url: '#' },
        ]}
      />

      <div className="mt-1">
        <TableActionsContainer>
          <div className="flex justify-content-end align-items-center gap-3 flex-wrap">
            <CustomButton
              varient="outline"
              type="button"
              label={'Back'}
              onClick={() => navigate('/marketplace/metadata')}
            />
          </div>
        </TableActionsContainer>
      </div>

      {/* Tabs */}
      <div className="p-3">
        <TabMenu
          model={tabItems}
          className="custom-tabmenu"
          activeIndex={tabMap.indexOf(activeTab)}
          onTabChange={(e) => setActiveTab(tabMap[e.index])}
        />
      </div>

      {activeTab === 'callSettings' && <CallSettings metadataId={metadataId} />}
      {activeTab === 'whatsappProfile' && <WhatsappProfile metadataId={metadataId} />}
      {activeTab === 'catalogConfig' && <CatalogueConfig metadataId={metadataId} />}
      {activeTab === 'usageConfig' && <Insight metadataId={metadataId} />}
      {activeTab === 'blockedUsers' && <BlockedUsersList metadataId={metadataId} />}
    </div>
  );
};

export default MetaDataInfo;
